module.exports = __webpack_public_path__ + "media/packs/images/flags/TT-54a2f24b04125bedf7ef28dcd1b13199.png";